module.exports = __webpack_public_path__ + "img/kt2.6cc3f473.png";